"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFooterWrapper = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
const StyledFooterWrapper = _styled.default.div`
    display: flex;
    padding: var(--sds--panel-footer--padding--top, var(--sds--panel-footer--padding-top, ${_designTokens.space.space40}))
        var(--sds--panel-footer--padding--right, var(--sds--panel-footer--padding-right, ${_designTokens.space.space45}))
        var(--sds--panel-footer--padding--bottom, var(--sds--panel-footer--padding-bottom, ${_designTokens.space.space45}))
        var(--sds--panel-footer--padding--left, var(--sds--panel-footer--padding-left, ${_designTokens.space.space45}));
    width: 100%;
    box-sizing: border-box;
    border-top: var(--sds--panel-footer--border--top, "none");
    gap: var(--sds--panel-footer--gap);
`;
exports.StyledFooterWrapper = StyledFooterWrapper;
//# sourceMappingURL=StyledPanelFooterComponents.js.map